import React from "react";
import HeaderOne from "./HeaderOne";
import FooterOne from "./FooterOne";

const OrderPolicy = () => {
  document.title = "Order Policy | MordenBazaar";

  return (
    <>
      <HeaderOne />

      <div className="page-content pt-0">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-9 col-xl-8">

              <h1 className="mt-4 mb-4">Order Cancellation & Return Policy</h1>

              {/* INTRO */}
              <ul className="list-disc pl-5 mb-5 space-y-2">
                <li>This policy explains how MordenBazaar handles cancellations, returns, replacements, and refunds.</li>
                <li>By placing an order, you agree to the terms mentioned below.</li>
              </ul>

              {/* 1 */}
              <h2 className="mt-5 mb-3">1. Cancellation Policy</h2>
              <ul className="list-disc pl-5 mb-4 space-y-3">
                <li>
                  <strong>Customer Cancellation (Before Dispatch):</strong>
                  <ul className="list-disc pl-6 mt-1">
                    <li>Orders can be cancelled anytime before dispatch without any charges.</li>
                  </ul>
                </li>

                <li>
                  <strong>Customer Cancellation (After Dispatch):</strong>
                  <ul className="list-disc pl-6 mt-1">
                    <li>Orders cancelled or rejected after dispatch incur a 10% cancellation fee.</li>
                  </ul>
                </li>

                <li>
                  <strong>How to Cancel:</strong>
                  <ul className="list-disc pl-6 mt-1">
                    <li>Login → My Orders → Cancel Order</li>
                    <li>Contact customer support via email or phone</li>
                  </ul>
                </li>

                <li>
                  <strong>Store-Initiated Cancellation:</strong>
                  <ul className="list-disc pl-6 mt-1">
                    <li>If cancelled due to stock or technical issues, a full refund is issued.</li>
                  </ul>
                </li>

                <li>
                  <strong>Refund Timeline:</strong>
                  <ul className="list-disc pl-6 mt-1">
                    <li>Refunds are processed within 3 working days to the original payment method.</li>
                  </ul>
                </li>
              </ul>

              {/* 2 */}
              <h2 className="mt-5 mb-3">2. Return, Exchange & Replacement Policy</h2>
              <ul className="list-disc pl-5 mb-4 space-y-3">
                <li>
                  <strong>Return Window:</strong>
                  <ul className="list-disc pl-6 mt-1">
                    <li>Return requests must be raised within 3 days of delivery.</li>
                  </ul>
                </li>

                <li>
                  <strong>Return Eligibility:</strong>
                  <ul className="list-disc pl-6 mt-1">
                    <li>Items must be unused, unwashed, undamaged, and include original tags & packaging.</li>
                  </ul>
                </li>

                <li>
                  <strong>Non-Eligible Returns:</strong>
                  <ul className="list-disc pl-6 mt-1">
                    <li>Used or damaged products will be returned without refund.</li>
                  </ul>
                </li>

                <li>
                  <strong>Documents Required:</strong>
                  <ul className="list-disc pl-6 mt-1">
                    <li>Invoice and unboxing video are mandatory for damaged or incorrect items.</li>
                  </ul>
                </li>

                <li>
                  <strong>Return Pickup:</strong>
                  <ul className="list-disc pl-6 mt-1">
                    <li>Return pickup is arranged by MordenBazaar where serviceable.</li>
                  </ul>
                </li>

                <li>
                  <strong>10% Cancellation Fee:</strong>
                  <ul className="list-disc pl-6 mt-1">
                    <li>Applicable to both change-of-mind and defective returns.</li>
                  </ul>
                </li>

                <li>
                  <strong>How to Start a Return:</strong>
                  <ul className="list-disc pl-6 mt-1">
                    <li>Login → My Orders → Return</li>
                    <li>Email support at <strong>support@mordenbazaar.com</strong></li>
                  </ul>
                </li>

                <li>
                  <strong>Possible Outcomes:</strong>
                  <ul className="list-disc pl-6 mt-1">
                    <li><strong>Exchange:</strong> Choose a different product</li>
                    <li><strong>Replacement:</strong> Same product (subject to availability)</li>
                    <li><strong>Refund:</strong> Processed within 3 business days after inspection</li>
                  </ul>
                </li>

                <li>
                  <strong>Inspection:</strong>
                  <ul className="list-disc pl-6 mt-1">
                    <li>All returned items must pass quality checks.</li>
                  </ul>
                </li>

                <li>
                  <strong>Damaged/Wrong Product Policy:</strong>
                  <ul className="list-disc pl-6 mt-1">
                    <li>Issues must be reported within 3 days of delivery with proof.</li>
                  </ul>
                </li>
              </ul>

              {/* 3 */}
              <h2 className="mt-5 mb-3">3. General Conditions</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>MordenBazaar may modify this policy at any time.</li>
                <li>Returned items must be securely packed during pickup.</li>
                <li>Refund status can be tracked from the user dashboard.</li>
              </ul>

              {/* 4 */}
              <h2 className="mt-5 mb-3">4. Customer Support</h2>
              <ul className="list-disc pl-5 mb-5 space-y-2">
                <li><strong>Email:</strong> support@mordenbazaar.com</li>
                <li><strong>Phone:</strong> [Add support number]</li>
                <li>Use the “My Orders” section on mordenbazaar.com</li>
              </ul>

            </div>
          </div>
        </div>
      </div>

      <FooterOne />
    </>
  );
};

export default OrderPolicy;